import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';
import history from '../../history';
import { STATUS } from '../../utils/status';
import { calculateWin } from '../CreateStake/OddsSlider';
import { updateStake } from '../../firebase';
import { updateUserBalanceAction } from '../rootReducer';

import ViewStake from './ViewStake';

class RequestCancelStake extends Component {
  static propTypes = {
    stake: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
  };

  state = {
    isLoading: false
  };

  cancelRequest = () => {
    this.setState({ isLoading: true });
    const stake = { ...this.props.stake };
    stake.status = STATUS.Live;
    delete stake.playerRequesting

    updateStake(stake, this.props.stake.id);
    history.push('/');
  };

  declineCancel = () => {
    // Notify canceller, opponent has declined their request
    this.cancelRequest();
  };

  acceptCancel = () => {
    this.setState({ isLoading: true });
    const stake = { ...this.props.stake };
    stake.status = STATUS.Nullified;

    // Return balance liabilities to both parties
    this.props.updateUserBalanceAction(stake.amount, stake.stakerId);

    const stakeeLiability = calculateWin(stake.amount, stake.odds);
    
    updateStake(stake, this.props.stake.id)
      .then(() => {
        this.props.updateUserBalanceAction(stakeeLiability, stake.stakee);
      });

    history.push('/');
  };
  
  render() {
    const { isLoading } = this.state;
    let { stake, user } = this.props;

    const isMyRequest = stake.playerRequesting === user.sub;
    return (
      <ViewStake
        stake={stake}
        actions={
            isMyRequest ? (
              <Button fluid primary size="large" loading={isLoading} disabled={isLoading} onClick={this.cancelRequest}>
                Cancel Request
              </Button>
            ) : (
            <div className="equal-width">
              <Button fluid color="grey" size="large" loading={isLoading} disabled={isLoading} onClick={this.declineCancel}>
                Decline
              </Button>
              <Modal
                size="mini"
                trigger={
                  <Button fluid negative size="large" loading={isLoading} disabled={isLoading}>
                    Accept
                  </Button>
                }
                header="Cancel Stake"
                content="Are you sure you want to cancel this stake?"
                actions={['No', { key: 'cancel', content: 'Yes, Cancel', primary: true, onClick: this.acceptCancel }]}
                />
            </div>
            )
        }
      />
    );
  }
}

export default connect(null, { updateUserBalanceAction })(RequestCancelStake);



// WEBPACK FOOTER //
// ./src/App/ViewStake/RequestCancelStake.js